import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const FilterControls = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  onExport,
  quotesCount 
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'received', label: 'Received' },
    { value: 'pending', label: 'Pending' },
    { value: 'expired', label: 'Expired' },
    { value: 'reviewing', label: 'Reviewing' }
  ];

  const sortOptions = [
    { value: 'price-asc', label: 'Price: Low to High' },
    { value: 'price-desc', label: 'Price: High to Low' },
    { value: 'rating-desc', label: 'Rating: High to Low' },
    { value: 'rating-asc', label: 'Rating: Low to High' },
    { value: 'delivery-asc', label: 'Delivery: Fastest First' },
    { value: 'date-desc', label: 'Date: Newest First' },
    { value: 'date-asc', label: 'Date: Oldest First' }
  ];

  const ratingOptions = [
    { value: 'all', label: 'All Ratings' },
    { value: '4+', label: '4+ Stars' },
    { value: '3+', label: '3+ Stars' },
    { value: '2+', label: '2+ Stars' }
  ];

  const hasActiveFilters = () => {
    return filters?.status !== 'all' || 
           filters?.rating !== 'all' || 
           filters?.search !== '' ||
           filters?.minPrice !== '' ||
           filters?.maxPrice !== '';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        {/* Left Side - Filters */}
        <div className="flex flex-col sm:flex-row gap-4 flex-1">
          {/* Search */}
          <div className="flex-1 min-w-0">
            <Input
              type="search"
              placeholder="Search vendors..."
              value={filters?.search}
              onChange={(e) => onFilterChange('search', e?.target?.value)}
              className="w-full"
            />
          </div>

          {/* Status Filter */}
          <div className="w-full sm:w-40">
            <Select
              options={statusOptions}
              value={filters?.status}
              onChange={(value) => onFilterChange('status', value)}
              placeholder="Status"
            />
          </div>

          {/* Rating Filter */}
          <div className="w-full sm:w-40">
            <Select
              options={ratingOptions}
              value={filters?.rating}
              onChange={(value) => onFilterChange('rating', value)}
              placeholder="Rating"
            />
          </div>

          {/* Sort */}
          <div className="w-full sm:w-48">
            <Select
              options={sortOptions}
              value={filters?.sort}
              onChange={(value) => onFilterChange('sort', value)}
              placeholder="Sort by"
            />
          </div>
        </div>

        {/* Right Side - Actions */}
        <div className="flex flex-col sm:flex-row gap-2">
          {hasActiveFilters() && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearFilters}
              iconName="X"
              iconPosition="left"
            >
              Clear Filters
            </Button>
          )}
          
          <Button
            variant="outline"
            size="sm"
            onClick={onExport}
            iconName="Download"
            iconPosition="left"
          >
            Export
          </Button>
        </div>
      </div>
      {/* Advanced Filters - Collapsible */}
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex flex-col sm:flex-row gap-4">
          {/* Price Range */}
          <div className="flex items-center space-x-2 flex-1">
            <span className="text-sm font-medium text-foreground whitespace-nowrap">Price Range:</span>
            <Input
              type="number"
              placeholder="Min"
              value={filters?.minPrice}
              onChange={(e) => onFilterChange('minPrice', e?.target?.value)}
              className="w-24"
            />
            <span className="text-text-secondary">-</span>
            <Input
              type="number"
              placeholder="Max"
              value={filters?.maxPrice}
              onChange={(e) => onFilterChange('maxPrice', e?.target?.value)}
              className="w-24"
            />
          </div>

          {/* Results Count */}
          <div className="flex items-center space-x-2 text-sm text-text-secondary">
            <Icon name="Filter" size={16} />
            <span>{quotesCount} {quotesCount === 1 ? 'quote' : 'quotes'} found</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterControls;